import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiCpu, FiGlobe, FiTv } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import TopBanner from '../../../components/topBanner/topBanner';
import bannerImg from '../../../images/banner/banner---gioi-thieu.png';
import softwareImg from '../../../images/product_solution/phan-mem-quan-ly-benh-vien.jpg';
import commerceImg from '../../../images/product_solution/banner-server.jpg';
import mediaImg from '../../../images/product_solution/banner-giaiphap-communication.jpg';
import TypicalProjectSlider from '../typicalProject/TypicalProjectSlider';
import './ecosystem-detail.scss';

function HsvCommerceOverview({ isEnglish }) {
    const { t } = useTranslation();

    const ecoPrefix = isEnglish ? '/ecosystem' : '/he-sinh-thai';

    const pillars = [
        {
            id: 'phan-mem',
            title: t('hsv_commerce_overview.software_title'),
            slug: `${ecoPrefix}/phan-mem`,
            image: softwareImg,
            tag: t('hsv_commerce_overview.software_tag'),
            icon: <FiCpu />,
            description: t('hsv_commerce_overview.software_desc'),
            linkText: t('hsv_commerce_overview.explore_btn'),
        },
        {
            id: 'thuong-mai',
            title: t('hsv_commerce_overview.commerce_title'),
            slug: `${ecoPrefix}/thuong-mai`,
            image: commerceImg,
            tag: t('hsv_commerce_overview.commerce_tag'),
            icon: <FiGlobe />,
            description: t('hsv_commerce_overview.commerce_desc'),
            linkText: t('hsv_commerce_overview.explore_btn'),
        },
        {
            id: 'truyen-thong',
            title: t('hsv_commerce_overview.media_title'),
            slug: `${ecoPrefix}/truyen-thong`,
            image: mediaImg,
            tag: t('hsv_commerce_overview.media_tag'),
            icon: <FiTv />,
            description: t('hsv_commerce_overview.media_desc'),
            linkText: t('hsv_commerce_overview.explore_btn'),
        },
    ];

    return (
        <main className="ecosystem-detail hsv-commerce-overview">
            <TopBanner
                titleCenter="HSV Thương Mại"
                imgBanner={bannerImg}
                pageName={isEnglish ? "Ecosystem" : "Hệ sinh thái"}
                text="HSV Thương Mại"
            />

            {/* Hero Summary Section */}
            <section className="layout_container ecosystem-detail__intro">
                <div className="hsv-corp-hero">
                    <span className="ecosystem-detail__eyebrow">
                        <FiGlobe /> {t('hsv_commerce_overview.badge')}
                    </span>
                    <h1>{t('hsv_commerce_overview.title')}</h1>
                    <p>{t('hsv_commerce_overview.subtitle')}</p>
                </div>
            </section>

            {/* Bento Grid Pillars Section */}
            <section className="layout_container ecosystem-detail__services">
                <div className="ecosystem-detail__heading">
                    <div>
                        <span>{t('hsv_commerce_overview.pillars_badge')}</span>
                        <h2>{t('hsv_commerce_overview.pillars_title')}</h2>
                    </div>
                </div>

                <div className="hsv-commerce-grid">
                    {pillars.map((pillar) => (
                        <div className="hsv-corp-card hsv-commerce-card" key={pillar.id}>
                            <div className="hsv-corp-card__image-wrap">
                                <img src={pillar.image} alt={pillar.title} />
                                <span className="hsv-corp-card__tag">{pillar.tag}</span>
                            </div>

                            <div className="hsv-corp-card__content">
                                <div className="hsv-commerce-card__header">
                                    <div className="hsv-commerce-card__icon">{pillar.icon}</div>
                                    <h3>{pillar.title}</h3>
                                </div>
                                <p>{pillar.description}</p>

                                <Link to={pillar.slug} className="hsv-corp-card__btn">
                                    <span>{pillar.linkText}</span>
                                    <FiArrowRight />
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Featured Slider Projects */}
            <section className="ecosystem-detail__projects layout_container">
                <div className="ecosystem-detail__heading">
                    <div>
                        <span>{t('hsv_commerce_overview.projects_badge')}</span>
                        <h2>{t('hsv_commerce_overview.projects_title')}</h2>
                    </div>
                </div>
                <TypicalProjectSlider variant="ecosystem" />
            </section>
        </main>
    );
}

export default HsvCommerceOverview;
